import { FeedbackConfigSchema } from '@/types/schema';

export const getFeedbackConfigSubtitle = (
  value: FeedbackConfigSchema,
  shortened?: boolean
) => {
  if (Array.isArray(value.feedback_config.categories)) {
    return shortened
      ? 'Categorical'
      : `Categories: ${value.feedback_config.categories
          .map((category) => category.label ?? category.value)
          .join(', ')}`;
  } else if (
    typeof value.feedback_config.max === 'number' ||
    typeof value.feedback_config.min === 'number'
  ) {
    let subtitle = shortened ? 'Continuous - ' : 'Continuous: ';
    if (typeof value.feedback_config.min === 'number') {
      subtitle += `Min: ${value.feedback_config.min}`;
    }
    if (typeof value.feedback_config.max === 'number') {
      subtitle += `${
        typeof value.feedback_config.min === 'number' ? ', ' : ''
      }Max: ${value.feedback_config.max}`;
    }
    return subtitle;
  } else if (value.feedback_config.type === 'continuous') {
    return shortened ? 'Continuous' : 'Continuous score';
  } else {
    return shortened ? 'Freeform' : 'Freeform text';
  }
};
